import { Component } from '@angular/core';
import { MedalliaService } from 'src/app/core';

@Component({
  selector: 'app-btn-opinion',
  templateUrl: './btn-opinion.component.html',
  styleUrls: ['./btn-opinion.component.scss'],
  standalone: false
})
export class BtnOpinionComponent {
  constructor(private medalliaService: MedalliaService) {}

  startSurvey() {
    const surveyKey = 'personasFeedBack';
    this.medalliaService.startSurvey(surveyKey);
  }
}
